import { clampOpacity } from './itemOpacity.js';
export function deriveDimNonActiveOpacityByConstellationKey(args) {
    const { entityConstellations, entityConstellationParametricStateByKey, dimming, effectiveActiveItemKeyByConstellationKey, effectiveLinkedActiveItemKeysByConstellationKey, } = args;
    if (!dimming)
        return {};
    const defaultOpacity = clampOpacity(dimming.defaultOpacity ?? 0.2);
    const out = {};
    for (const constellation of entityConstellations) {
        const constellationKey = constellation.constellationKey;
        const layoutKind = entityConstellationParametricStateByKey?.[constellationKey]?.layout?.layoutKind;
        if (!layoutKind)
            continue;
        const enabledByConstellation = dimming.enabledByConstellationKey?.[constellationKey];
        const enabledByLayoutKind = dimming.enabledByLayoutKind?.[layoutKind];
        const isEnabled = enabledByConstellation ?? enabledByLayoutKind ?? false;
        if (!isEnabled)
            continue;
        const hasActiveItem = effectiveActiveItemKeyByConstellationKey[constellationKey] !== undefined;
        const hasLinkedActiveItem = (effectiveLinkedActiveItemKeysByConstellationKey[constellationKey]?.size ?? 0) > 0;
        if (!hasActiveItem && !hasLinkedActiveItem)
            continue;
        const opacityByConstellation = dimming.opacityByConstellationKey?.[constellationKey];
        const opacityByLayoutKind = dimming.opacityByLayoutKind?.[layoutKind];
        out[constellationKey] = clampOpacity(opacityByConstellation ?? opacityByLayoutKind ?? defaultOpacity);
    }
    return out;
}
export function deriveLinkedActiveMapFromActivationLinks(args) {
    const { directActiveItemKeyByConstellationKey, activationLinks } = args;
    const derivedLinkedActive = new Map();
    const addLinkedItem = (constellationKey, itemKey) => {
        let set = derivedLinkedActive.get(constellationKey);
        if (!set) {
            set = new Set();
            derivedLinkedActive.set(constellationKey, set);
        }
        set.add(itemKey);
    };
    for (const activationLink of activationLinks ?? []) {
        const sourceItemKey = directActiveItemKeyByConstellationKey[activationLink.sourceConstellationKey];
        if (!sourceItemKey)
            continue;
        const targetItemKeys = activationLink.targetItemKeysBySourceItemKey[sourceItemKey];
        if (!targetItemKeys)
            continue;
        if (directActiveItemKeyByConstellationKey[activationLink.targetConstellationKey])
            continue;
        for (const targetItemKey of targetItemKeys) {
            addLinkedItem(activationLink.targetConstellationKey, targetItemKey);
        }
    }
    for (const [constellationKey, itemSet] of derivedLinkedActive.entries()) {
        const activeItemKey = directActiveItemKeyByConstellationKey[constellationKey];
        if (activeItemKey)
            itemSet.delete(activeItemKey);
        if (itemSet.size === 0)
            derivedLinkedActive.delete(constellationKey);
    }
    const out = {};
    for (const [constellationKey, itemSet] of derivedLinkedActive.entries())
        out[constellationKey] = itemSet;
    return out;
}
